<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="6"
                lg="10"
                md="8"
                sm="6"
            >
                <h3>To Do Manager</h3>
            </v-col>
            <v-col 
                style="text-align: right;"
                cols="6"
                lg="2"
                md="4"
                sm="6"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            :to="{ name: 'toDoManagerForm', params: {id: 0} }"
                        >
                            New
                        </v-btn>
                    </template>
                    <span>New</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Quick Search"
                        prepend-inner-icon="mdi mdi-magnify"
                        outlined
                        single-line
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredSearch"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >   
                    <template v-slot:item.statusDescription="{ item }">
                        <v-chip
                            :color="getStatusColor(item.status)"
                            outlined
                            dark
                        >
                            {{ item.statusDescription }}
                        </v-chip>
                    </template>

                    <template v-slot:item.action="{item}">
                        <ActionList 
                            :id="item.id" 
                            :link="'toDoManagerForm'"
                            :showButtons="{
                                edit: true,
                                delete: true,
                                view: true,
                                cancel: item.status === 1 ? true : false,
                                active: item.status === 0 ? true : false
                            }"
                            @confirmDelete="confirmDelete"
                            @confirmCancel="confirmCancel"
                            @confirmActive="confirmActive" 
                            @confirmView="confirmView" 
                        />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />
        
		<v-dialog
			v-model="showHistoryDialog"
			transition="dialog-top-transition"
			persistent
			width="800"
			:fullscreen="$vuetify.breakpoint.mobile"
		>
			<v-card>
				<v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
					History
				</v-card-title>

				<v-card-text>
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="6"
                            md="6"
                            sm="12"
                        >
                            <v-menu
                                ref="mnuStartDate"
                                v-model="mnuStartDate"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="300px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <label>Start Date</label>
                                    <v-text-field
                                        v-model="filterHistoryRequest.startDateFormatted"
                                        prepend-inner-icon="mdi-calendar"
                                        v-mask="'##/##/####'"
                                        v-bind="attrs"
                                        outlined
                                        single-line
                                        v-on="on"
                                        dense
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filterHistoryRequest.startDate"
                                    no-title
                                    @input="mnuStartDate = false"
                                    color="primary lighten-1"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col 
                            cols="12"
                            lg="6"
                            md="6"
                            sm="12"
                        >
                            <v-menu
                                ref="mnuEndDate"
                                v-model="mnuEndDate"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="300px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <label>End Date</label>
                                    <v-text-field
                                        v-model="filterHistoryRequest.endDateFormatted"
                                        prepend-inner-icon="mdi-calendar"
                                        v-mask="'##/##/####'"
                                        v-bind="attrs"
                                        outlined
                                        single-line
                                        v-on="on"
                                        dense
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filterHistoryRequest.endDate"
                                    no-title
                                    @input="mnuEndDate = false"
                                    color="primary lighten-1"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col
                            cols="12"
                            lg="6"
                            md="12"
                            sm="12"
                        >
                            <label>Profile</label>
                            <v-combobox
                                v-model="filterHistoryRequest.profileSelected"
                                :items="listProfile"
                                item-text="name"
                                item-value="id"
                                clearable
                                single-line
                                outlined
                                @change="filterUser(); getRegisters(); filterHistoryRequest.userSelected = null"
                                dense
                            ></v-combobox>
                        </v-col>
                        <v-col 
                            cols="12"
                            lg="4"
                            md="4"
                            sm="12"
                        >
                            <label>User</label>
                            <v-combobox
                                v-model="filterHistoryRequest.userSelected"
                                :items="listUser"
                                item-text="name"
                                item-value="id"
                                clearable
                                single-line
                                outlined
                                dense
                                @change="getRegisters()"
                            ></v-combobox>
                        </v-col>
                        <v-col 
                            style="text-align: right; margin-top: 22px;"
                            cols="12"
                            lg="2"
                            md="2"
                            sm="12"
                        >
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="getHistory"
                                    >
                                        Refresh
                                    </v-btn>
                                </template>
                                <span>Refresh</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                :headers="headersHistory"
                                :items="listHistory"
                                :options.sync="optionsHistory"
                                :loading="loading"
                                :items-per-page="30"
                                no-data-text="No Record Found"
                            >   
                            </v-data-table>
                        </v-col>
                    </v-row>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<div style="width: 100%; text-align: center;">
						<v-btn
							class="mx-2 dialogButtonDismiss v-btn-large"
							outlined
							@click="closeHistoryDialog()"
						>
							Back
						</v-btn>
					</div>
				</v-card-actions>
			</v-card>
		</v-dialog>

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import ActionList from "@/components/Layout/ActionList";
    import ActionDialog from "@/components/Layout/ActionDialog";
    import * as moment from 'moment';
    export default ({

        components: {
            ActionList,
            ActionDialog
        },

        mixins: [Helpers],
        data: vm => ({

            id: 0,

            loading: false,

            filter: {
                fastSearch: ''
            },

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            headers: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Created By", value: "userNameRegister", sortable: true },
                { text: "Title", value: "title", sortable: true },
                { text: "Period", value: "typeDescription", sortable: true },
                { text: "Type", value: "typeToDoDescription", sortable: true },
                { text: "Profile", value: "profileSelected.name", sortable: true },
                { text: "User", value: "userSelected.name", sortable: true },
                { text: "Start On", value: "dateStartFormatted", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            options: { rowsPerPage: 10, page: 1 },

            listToDoManager: [],

            showHistoryDialog: false,

            listUser: [],
            listUserClone: [],
            listProfile: [],
            
            today: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateMeeting: vm.today,
            dateMeetingFormatted: vm.formatDate(vm.today),

            filterHistoryRequest: {
                profileSelected: null,
                userSelected: null,
                startDate: moment().clone().format('YYYY-MM-DD'),
                endDate: moment().clone().format('YYYY-MM-DD'),
                startDateFormatted: moment().clone().format('MM/DD/YYYY'),
                endDateFormatted: moment().clone().format('MM/DD/YYYY')
            },
            
            mnuStartDate: false,
            mnuEndDate: false,

            headersHistory: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Registered On", value: "dateRegisterFormatted", sortable: true },
                { text: "User", value: "userName", sortable: true },
                { text: "Description", value: "description", sortable: true }
            ],
            optionsHistory: { rowsPerPage: 30, page: 1 },

            listHistory: [],
        }),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            filteredSearch: function() {

                if (this.listToDoManager != null && this.listToDoManager != undefined) {
                    return this.listToDoManager.filter((toDoManagerFilter) => {
                        
                        const filter = this.filter.fastSearch.toLowerCase();

                        var title = toDoManagerFilter.title.toLowerCase().match(filter)
                        var userNameRegister = toDoManagerFilter.userNameRegister != null && toDoManagerFilter.userNameRegister != undefined ? toDoManagerFilter.userNameRegister.toLowerCase().match(filter) : ""
                        var typeDescription = toDoManagerFilter.typeDescription != null && toDoManagerFilter.typeDescription != undefined ? toDoManagerFilter.typeDescription.toLowerCase().match(filter) : ""
                        var typeToDoDescription = toDoManagerFilter.typeToDoDescription != null && toDoManagerFilter.typeToDoDescription != undefined ? toDoManagerFilter.typeToDoDescription.toLowerCase().match(filter) : ""
                        var userSelected = toDoManagerFilter.userSelected != null && toDoManagerFilter.userSelected != undefined ? toDoManagerFilter.userSelected.name.toLowerCase().match(filter) : ""
                        var profileSelected = toDoManagerFilter.profileSelected != null && toDoManagerFilter.profileSelected != undefined ? toDoManagerFilter.profileSelected.name.toLowerCase().match(filter) : ""
                        var id = toDoManagerFilter.id.toString().match(filter);

                        if(title != null) { return title; } 
                        else if(userNameRegister != null) { return userNameRegister; } 
                        else if(typeDescription != null) { return typeDescription; } 
                        else if(typeToDoDescription != null) { return typeToDoDescription; } 
                        else if(userSelected != null) { return userSelected; }
                        else if(profileSelected != null) { return profileSelected; }
                        else { return id; }
                    });
                }
                else {
                    return null;
                }
            }
        },

        watch: {
            "filter.startDate" () {
                this.filter.startDateFormatted = this.formatDate(this.filter.startDate)
                this.getRegisters();
            },

            "filter.endDate" () {
                this.filter.endDateFormatted = this.formatDate(this.filter.endDate)
                this.getRegisters();
            },
        },

        methods: {

            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

            getStatusColor (status) {

                let color = "";

                switch (status) {

                    case 1:
                        color = 'var(--color__main)';
                        break;

                    case 0:
                        color = 'var(--color__cinza_escuro)';
                        break;
                
                    default:
                        break;
                }

                return color
            },

            confirmDelete(id) {

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will DELETE this register, confirm your decision?',
                    methodConfirm: this.delete,
                    params: id
                };

            },

            async delete(id) {

                this.showLoading();

                const result = await this.$store.dispatch("toDoManagerModule/Delete", id);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            confirmCancel(id) {

                this.statusId = 0;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will INACTIVATE this task, confirm your decision?',
                    methodConfirm: this.cancel,
                    params: id
                };
            },

            async cancel(id) {

                let statusId = this.statusId;

                this.showLoading();

                let result = await this.$store.dispatch("toDoManagerModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            confirmActive(id) {

                this.statusId = 1;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will ACTIVATE this task, confirm your decision?',
                    methodConfirm: this.active,
                    params: id
                };

            },

            async active(id) {

                this.showLoading();
                let statusId = this.statusId;

                let result = await this.$store.dispatch("toDoManagerModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            async getRegisters() {
                this.listToDoManager = await this.$store.dispatch("toDoManagerModule/List");
            },

            confirmView(id) {
                this.id = id;
                this.showHistoryDialog = true;
                this.getHistory();
            },
            
            closeHistoryDialog() {
                this.showHistoryDialog = false;
            },
            

            async filterUser () {

                this.showLoading();

                if (this.filterHistoryRequest.profileSelected != null && this.filterHistoryRequest.profileSelected != undefined) {
                    this.filterHistoryRequest.idProfile = this.filterHistoryRequest.profileSelected.id;
                    this.listUser = this.listUserClone.filter(usr => usr.idProfile == this.filterHistoryRequest.idProfile)
                }

                if (this.filterHistoryRequest.userSelected != null && this.filterHistoryRequest.userSelected != undefined) {
                    this.filterHistoryRequest.idUser = this.filterHistoryRequest.userSelected.id
                }

                this.hideLoading();
            },

            async loadProfilesAndUsers() {
                
                this.listProfile = await this.$store.dispatch("profileModule/List");
                let listUser = await this.$store.dispatch("userModule/List");
                let idProfileSelected = 0;

                if (this.filterHistoryRequest.profileSelected != null && 
                    this.filterHistoryRequest.profileSelected != undefined && 
                    this.filterHistoryRequest.profileSelected.id != 0) {
                    idProfileSelected = this.filterHistoryRequest.profileSelected.id;

                    listUser = listUser.filter(usr => usr.idProfile == idProfileSelected);
                }

                this.listUser = [...listUser];
                this.listUserClone = [...listUser];

                if (this.userLoggedGetters.listIDUsers != null && 
                    this.userLoggedGetters.listIDUsers != undefined &&
                    this.userLoggedGetters.listIDUsers.toString().trim() != '') {
                    const listIDUsers = this.userLoggedGetters.listIDUsers.toString().split(';');

                    let newListUsers = [];

                    listIDUsers.forEach(idUser => {

                        if (idUser != null && idUser != undefined && idUser.toString().trim() != '') {
                            const userFiltered = listUser.filter(item => item.id.toString() == idUser)[0];

                            if (userFiltered && userFiltered != null && userFiltered != undefined) {
                                newListUsers.push(userFiltered);
                                this.listUser = newListUsers;
                            }
                        }
                    });
                }
            },

            getFilterRequest() {

                let idProfile = 0;
                let idUser = 0;

                if (this.filterHistoryRequest.profileSelected != null && this.filterHistoryRequest.profileSelected != undefined) {
                    idProfile = this.filterHistoryRequest.profileSelected.id;
                }

                if (this.filterHistoryRequest.userSelected != null && this.filterHistoryRequest.userSelected != undefined) {
                    idUser = this.filterHistoryRequest.userSelected.id;
                }

                const startDate = this.filterHistoryRequest.startDate;
                const endDate = this.filterHistoryRequest.endDate;
                
                const request = {
                    idToDoManager: this.id,
                    idProfile,
                    idUser,
                    startDate,
                    endDate
                }

                return request;
            },

            async getHistory() {
                this.showLoading();

                const request = this.getFilterRequest();

                this.listHistory = await this.$store.dispatch("toDoManagerModule/ListHistory", request);

                this.hideLoading();
            }

        },

        async created() {
            this.showLoading();
            await this.getRegisters();
            await this.loadProfilesAndUsers();
            await this.filterUser();
            this.hideLoading();
        }
    })
</script>
